import * as yup from 'yup'

export const validateCreateRecipes = yup.object().shape({
    name:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
    category_id:yup
    .string()
    .required('Campo requerido.'),
    path_cover:yup
    .string()
    // .required('Campo requerido.')
    .min(2, 'LA IMAGEN debe tener más de 2 caracteres'),
    short_description: yup
    .string()
    // .required('Campo requerido.')
    .min(2, 'LA DESCRIPCIÓN CORTA debe tener más de 2 caracteres'),
    description:yup
    .string()
    // .required('Campo requerido.')
    .min(2, 'LA DESCRIPCIÓN debe tener más de 2 caracteres'),
    rating_score:yup
    .number()
    .positive()
    .typeError('Campo requerido.')
    // .required('Campo requerido.')
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    user_id:yup
    .string(),
    // .required('Campo requerido.'),
    html_ingredients: yup
    .string()
    // .required('Campo requerido.')
    .min(2, 'LOS INGREDIENTES debe tener más de 2 caracteres'),
    html_steps: yup
    .string()
    // .required('Campo requerido.')
    .min(2, 'LOS PASOS debe tener más de 2 caracteres'),


    // status:yup
    // .string()
    // .required('Campo requerido.')
    // .oneOf(['active', 'inactive'], 'Debes elegir entre estas opciones'),
})